var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"isLoggedIn":_vm.isLoggedIn}}),_c('div',{staticClass:"menu"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"studio?type=feeder_table"}},[_c('div',{staticClass:"thumb"},[_c('img',{attrs:{"src":"img/eformel/preview/results.png"}})]),_c('span',[_vm._v("Results")])])],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }